import React, { Component } from "react";
import throttle from "lodash.throttle";

import { getImageUrl } from "../../utils/helper";
import IconSpinner from "../icons/spinner";

class Image extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageLoaded: false,
            wrapperWidth: null,
        };

        this._getWrapperWidth = this._getWrapperWidth.bind(this);
    }

    componentDidMount() {
        this._getWrapperWidth();

        if (window && window.addEventListener) {
            window.addEventListener(
                "resize",
                throttle(this._getWrapperWidth, 300)
            );
        }
    }

    _getWrapperWidth() {
        if (this._ref) {
            let size = this._ref.getBoundingClientRect();

            this.setState({
                wrapperWidth: size.width,
            });
        }
    }

    _renderLoading() {
        let opacity = this.state.imageLoaded ? 0 : 1;

        if (this.state.imageLoaded) return null;

        return (
            <div
                className="flex justify-center items-center absolute w-full h-full transition duration-1000 ease-in-out"
                style={{ opacity }}
            >
                <IconSpinner className="mx-auto animate-spin h-25 w-25 text-blue" />
            </div>
        );
    }

    _renderImage() {
        const {
            alt,
            url,
            aspectRatio,
            width,
            height,
            withHoverAnimation,
            cover,
            heightFull,
        } = this.props;
        const { wrapperWidth, imageLoaded } = this.state;

        if (!wrapperWidth || !url) return null;

        let imageUrl = getImageUrl(url, wrapperWidth);

        let className = "w-full transition duration-1000 ease-out";
        if (heightFull) {
            className += " h-full";
        }
        if ((width && height) || aspectRatio) {
            className += " absolute";
        }
        if (cover) {
            className += " object-cover";
        } else {
            className += " object-contain";
        }

        if (withHoverAnimation) {
            className += " transform hover-hover:hover:scale-110";
            return (
                <div>
                    <img
                        alt={alt}
                        title={alt}
                        draggable={false}
                        className={className}
                        style={{ opacity: imageLoaded ? 1 : 0 }}
                        src={imageUrl}
                        onLoad={() => {
                            this.setState({
                                imageLoaded: true,
                            });
                        }}
                    />
                </div>
            );
        }

        return (
            <img
                alt={alt}
                title={alt}
                draggable={false}
                className={className}
                style={{ opacity: imageLoaded ? 1 : 0 }}
                src={imageUrl}
                onLoad={() => {
                    this.setState({
                        imageLoaded: true,
                    });
                }}
            />
        );
    }

    render() {
        const { aspectRatio, styleExtra, width, height } = this.props;

        let style = {};
        let className = "relative overflow-hidden bg-light-grey w-full";
        if (width && height) {
            style = {
                paddingBottom: (height / width) * 100 + "%",
            };
        } else if (aspectRatio) {
            className += " " + aspectRatio;
        } else {
            className += " h-full";
        }

        if (styleExtra) {
            className += " " + styleExtra;
        }

        return (
            <div
                ref={(ref) => (this._ref = ref)}
                className={className}
                style={style}
            >
                {this._renderLoading()}
                {this._renderImage()}
            </div>
        );
    }
}

Image.defaultProps = {
    aspectRatio: "aspect-ratio-9/10",
    width: null,
    height: null,
    styleExtra: null,
    withHoverAnimation: false,
    alt: null,
    cover: true,
    heightFull: true,
};

export default Image;
